import { render, staticRenderFns } from "./CdbCustomerPage.vue?vue&type=template&id=17391d7b&"
import script from "./CdbCustomerPage.vue?vue&type=script&lang=js&"
export * from "./CdbCustomerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports